/**
 * Common Style
 */

import { theme } from './theme';
import { StyleSheet, Dimensions, StatusBar, Platform } from 'react-native';
import {
  getDeviceHeight,
  getDeviceWidth,
  isAndroid,
  isIOS,
  isWeb,
} from './utils/Helper';
const { width, height } = Dimensions.get('window');



export const PRIMARY_FONT = theme?.PRIMARY_FONT || {
  fontFamily: 'AlegreSans-Regular',
  fontWeight: 400,
}

export const SECONDARY_FONT = theme?.SECONDARY_FONT || {
  fontFamily: 'Plain-Regular',
  fontWeight: 400,
}

export const FONT_XSMALL = theme?.FONT_XSMALL || {
  fontSize: 10,
  lineHeight: 16,
  letterSpacing: -0.2,
  fontWeight: 500
}

export const FONT_SMALL = theme?.FONT_SMALL || {
  fontSize: 14,
  lineHeight: 21,
}

export const FONT_MEDIUM = theme?.FONT_MEDIUM || {
  fontSize: 16,
  lineHeight: 24,
}

export const FONT_LARGE = theme?.FONT_LARGE || {
  fontSize: 24,
  lineHeight: 30,
}

export const FONT_XLARGE = theme?.FONT_XLARGE || {
  fontSize: 40,
  lineHeight: 44,
}

export const FONT_XXLARGE = theme?.FONT_XXLARGE || {
  fontSize: 48,
  lineHeight: 52,
}


export const COLORS = {
  WHITE: "#ffffff",
  BLACK: "#000000",
  LIGHT_GREY: "#F5F5F5",

  BACKGROUND_COLOR: '#F1F0E4', // background color for main containers
  BACKGROUND_COLOR_CONTRAST: '#1D1D1D',

  BACKGROUND_COLOR_SECONDARY: "#1D1D1D", // secondary background color (eg: footer)
  BACKGROUND_COLOR_SECONDARY_CONTRAST: "#FFFFFF",

  PRIMARY_COLOR: "#FFFFFF", // primary color
  PRIMARY_TEXT_COLOR: "#1D1D1D", // primary text color

  SECONDARY_COLOR: "#1D1D1D", // secondary color
  SECONDARY_TEXT_COLOR: "#ffffff", // secondary text color

  ACCENT_COLOR: "#BD2611",
  ACCENT_Text_COLOR: "#FFFFFF",


  ...theme?.COLORS,
}

export const GENERAL_MAX_WIDTH = theme?.GENERAL_MAX_WIDTH || 1080
export const GENERAL_MAX_WIDTH_SECONDARY = theme?.GENERAL_MAX_WIDTH_SECONDARY || 600



export default StyleSheet.create({

  rootContainer: {
    flex: 1,
    margin: "auto",
    width: "100%",
    maxWidth: GENERAL_MAX_WIDTH,
  },


  /**
 * 
 * MAIN LAYOUT
 * 
 */
  tabBarStyle: {
    height: 84,
    backgroundColor: COLORS.BACKGROUND_COLOR_SECONDARY,
    paddingLeft: 0,
    paddingRight: 0,
  },
  tabContainerTopBorder_container: {

  },
  tabContainerTopBorder: {
    borderTopWidth: 3,
    borderTopColor: COLORS.ACCENT_COLOR,
  },
  tabContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 6,
    gap: 8,
    flex: 1,
  },
  tabParentContainer:{

  },
  tabFocusedContainer: {

  },
  tabLabel: {
    ...SECONDARY_FONT,
    ...FONT_XSMALL,
    textTransform: 'uppercase',
    color: COLORS.BACKGROUND_COLOR_SECONDARY_CONTRAST,
  },
  tabLabelFocused: {
    color: COLORS.BACKGROUND_COLOR_SECONDARY_CONTRAST,
  },
  tabIcon: {
    width: 24,
    height: 24,
  },
  tabIconFocused: {

  },

  errorContainer: {
    flex: 1,
    width: "100%",
    margin: "auto",
    justifyContent: "center",
    alignItems: 'center',
    padding: 16,
    gap: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    maxWidth: GENERAL_MAX_WIDTH
  },
  errorTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  errorImage: {
    height: "40%",
    resizeMode: 'contain',
  },
  errorMessage: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  errorRetryButton: {

  },
  errorRetryText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: 'center',
    color: '#007BFF',
  },
  errorHereText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: 'bold',
  },
  errorDetails: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textAlign: "center",
    color: 'red',
  },


  /* Main HomePage Container */
  mainRootContainer: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  mainContainer: {
    flex: 1,
    // marginTop: 393,
    // backgroundColor: COLORS.BACKGROUND_COLOR,
    // height: 393
  },
  mainContainerParallaxContainer: {
    marginTop: 246,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  mainContainerHeaderContainer: {
    display: "flex",
    justifyContent: 'center',
    width: "100%"
  },
  mainContainerHeaderImg: {
    width: "100%",
    height: 393,
    maxWidth: 1000,
    margin: "auto",
    objectFit: "cover"
  },
  mainContainerHeaderTitleContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    gap: 16,
    paddingVertical: 32,
    paddingHorizontal: 16
  },
  mainContainerHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XXLARGE,
    textTransform: "uppercase",
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  mainContainerWidgetsContainer: {
    paddingBottom: 148
  },
  mainContainer_logout_button: {
    paddingHorizontal: 16, 
    paddingBottom: 40
  },

  /** Bookmark popup */
  bookmarkRootContainer: {
    position: "absolute", 
    bottom: 60, 
    maxWidth: 300, 
    paddingHorizontal: 8, 
    alignItem: "center", 
    zIndex: 1000, 
    backgroundColor: COLORS.BACKGROUND_COLOR, 
    justifySelf: "center", 
    alignSelf: "center", 
    margin: "auto", 
    borderRadius: 10,

    borderWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.1)",

    elevation: 2,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  }, 
  bookmarkTextContainer: {
    padding: 16
  },
  bookmarkTextCloseContainer: {
    position: "absolute",
    right: 12
  },
  bookmarkTextCloseText: {
    ...FONT_SMALL,
    ...PRIMARY_FONT,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  bookmarkPopupText: {
    ...FONT_XSMALL,
    ...PRIMARY_FONT,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    paddingRight: 12,
    paddingTop: 12,
  },

  /**
 *
 * INFO WIDGET STYLE
 *
  ₹ */
  infoWidgetsWidgetContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 16,
    padding: 16,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  infoWidgetHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XXLARGE,
    textTransform: "uppercase",
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center'
  },
  infoWidgetHeaderSubtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingHorizontal: 24,
    textAlign: "center"
  },
  infoWidgetImageStyle: {
    width: '100%',
    height: 230,
  },
  infoWidgetButtonContainer: {
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    width: "100%",
    height: 48,
    paddingHorizontal: 24,
    paddingVertical: 8,
    borderWidth: 1,
  },
  infoWidgetButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },



  /**
   * Way Activities
   */

  wayBookingsLoader: {
    tintColor: COLORS.BLACK,
  },

  activitiesBookingMainContainerChildContainer: {
    marginBottom: 90
  },
  activitiesCreateBookingTimeSlots: {
    marginTop: 12
  },
  activitiesCreateBookingNoSessions: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none"
  },

  activitiesBookingCheckedBox: {
    display: "flex",
    width: 20,
    height: 20,
    // borderWidth: 1,
    // borderColor: 'grey',
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.ACCENT_COLOR,
  },

  activitiesEventListHeaderContainer: {
    gap: 8,
    marginBottom: 8,
    paddingHorizontal: 16,

    display: "flex",
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
  },
  activitiesBookingMainContainerHeader: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginVertical: 8
  },
  activitiesBookingMainPageHeaderTitleContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  activitiesBookingHeaderTitleContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  activitiesBookingHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none",
    textAlign: "left",
    width: "100%"
  },
  activitiesBookingEventListHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none",
    textAlign: "center",
    width: "100%"
  },
  activitiesBookingHeaderSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingHorizontal: null,
    textAlign: "left",
    width: "100%"
  },
  activitiesBookingHeaderSubTitle2: {
    paddingHorizontal: null,
    textAlign: "left",
    width: "100%"
  },
  activitiesBookingSubItemContainer: {
    display: "flex",
    // justifyContent: "space-between",
    flexDirection: "row",
  },
  activitiesBookingItemDay: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 16,
  },
  activitiesBookingDateContainer: {
    gap: 4,
    flex: 1
  },
  activitiesBookingBookingExperienceText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  activitiesBookingBookingExperienceDate: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  activitiesBookingEditButtonContainer: {
    // height: 20,
    // width: 20
  },
  activitiesBookingEditButton: {
    height: 20,
    width: 20,
    objectFit: "cover"
  },
  activitiesBookingOverviewHeadingText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 8
  },
  activitiesBookingOverviewHeadingPriceTierText: {
    marginBottom: null
  },
  activitiesBookingOverviewTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 16
  },
  activitiesBookingOverviewParticipantsContainer: {
    minHeight: 60
  },
  activitiesBookingOverviewParticipantsItemContainer: {
    marginVertical: 8
  },
  activitiesBookingOverviewParticipantsItemText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  activitiesBookingNoReservationFoundContainer: {
    flexDirection: "row"
  },
  activitiesBookingNoReservationTxt: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  activitiesBookingNoReservationRetry: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: "black"
  },

  activitiesEventListFilterContainer: {
    borderRadius: 16,
    borderWidth: 1,
    backgroundColor: COLORS.PRIMARY_COLOR,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderColor: "rgba(0, 0, 0, 0.10)"
  },
  activitiesEventListTextContainer: {
    paddingHorizontal: 16,
  },
  activitiesBookingOverviewTextContainer: {
    marginBottom: 8,
    marginTop: 16,
  },
  activitiesEventListItemImage: {
    objectFit: "cover",
    height: 165,
    borderRadius: 8,
  },
  activitiesEventListItemContent: {
    // height: 135,
    justifyContent: "center",
    marginBottom: 24,
    gap: 4
  },
  activitiesEventListItemSubContent: {
    height: 140,
  },
  activitiesSubEventListItemContainer: {
    paddingHorizontal: 16,
    flexDirection: "row",
    alignItems: "flex-start",
  },
  activitiesEventList_itemContainer_arrow: {
    justifySelf: "center",
    alignSelf: 'center'
  },
  activitiesEventList_itemContainer_selected: {
    backgroundColor: COLORS.ACCENT_COLOR
  },
  activitiesEventList_itemContainer_image_selected: {

  },
  activitiesSubEvent_itemContainer_textContainer_selected: {

  },
  activitiesSubEventListItemImageContainer: {
    height: 145,
    width: 145,
  },
  activitiesSubEventListItemImage: {
    objectFit: "cover",
    height: 145,
    width: 145,
    borderRadius: 8,
  },
  emptyStateText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  activitiesEventListContainer: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingVertical: 16
  },
  activitiesEventListItemTitleContainer: {
    marginTop: 14,
  },
  activitiesEventListItemTitle: {
    // color: COLORS.PRIMARY_TEXT_COLOR,
    // ...SECONDARY_FONT,
    // ...FONT_MEDIUM,
    marginTop: 8
  },
  activitiesEventListItemSubtitle: {
    // color: COLORS.PRIMARY_TEXT_COLOR,
    // ...SECONDARY_FONT,
    // ...FONT_MEDIUM,
  },
  activitiesCreateBookingItemContainer: {
    paddingVertical: null,
  },
  
  activitiesEventListFilterContainerActive: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderColor: COLORS.SECONDARY_COLOR,
  },
  activitiesEventListFilterName: {
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  activitiesEventListFilterNameActive: {
    color: COLORS.SECONDARY_TEXT_COLOR
  },

  activitiesEventListMainContainerChildContainer: {
    paddingHorizontal: 16,
    marginBottom: 88
  },
  activitiesSubEventListMainContainerChildContainer: {
    paddingHorizontal: 0,
    marginBottom: 88
  },

  activitiesCreateBookingMainContainerChildContainer: {
    marginBottom: 88
  },
  
  activitiesCreateBookingTimeSlotsContainer: {
    flexDirection: "row",
    gap: 8,
    marginVertical: 12
  },
  activitiesEventTitleText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
    paddingVertical: 32
  },
  activitiesFirstAvailableDateText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingTop: 4
  },
  activitiesFirstAvailableDateLabel: {
    marginBottom: 12
  },
  spaBookingRetryButtonContainer: {
    color: COLORS.SECONDARY_COLOR
  },

  activitiesCreateBookingAddonHeading: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  activitiesCreateBookingButtonContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    gap: 16,
  },
  activitiesCreateBookingButtonMinusContainer: {

  },
  activitiesCreateBookingButtonAddMinus: {
    width: 24,
    height: 24,
  },
  
  activitiesCreateBookingButtonQuantityText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  activitiesCreateBookingTimeSlotsItemContainer: {
    padding: 8,
    borderWidth: 1,
    borderColor: COLORS.BLACK,
    borderRadius: 5
  },

  activitiesCreateBookingTimeSlotsItemSelectedContainer: {
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  activitiesCreateBookingTimeSlotsItemSelectedText: {
    color: COLORS.SECONDARY_TEXT_COLOR,
  },

  activitiesBookingNextButtonContainer: {
    bottom: 0,
    width: '100%',
    position: 'absolute',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },
  
  activitiesCreateBookingSelectedEventContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 16,
  },
  activitiesCreateBookingSelectedEventTextContainer: {
    maxWidth: 262,
    gap: 4
  },
  activitiesCreateBookingSelectedEventTextName: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  activitiesCreateBookingSelectedEventTextPrice: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  activitiesCreateBookingHeaderTitleContainer: {
    gap: null,
    alignItems: "flex-start"
  },

  activitiesAdditionlaDetailsHeaderTitleContainer: {
    // justifyContent: "flex-start",
    // alignItems: "flex-start",
    // paddingBottom: 8,
  },
  activitiesAdditionlaDetailsHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },
  activitiesAdditionlaDetailsHeaderSubTitle: {

  },
  
  activitiesCreateBookingSelectedEventButtonContainer: {
    flexDirection: "row",
    gap: 8,
    justifyContent: "center",
    alignItems: "center"
  },

  activitiesCreateBookingSelectedEventMinusButtonContainer: {
    height: 23,
    width: 23
  },
  activitiesCreateBookingSelectedEventMinusButton: {
    objectFit: "cover",
    height: 23,
    width: 23
  },
  activitiesCreateBookingSelectedEventAddButtonContainer: {
    height: 23,
    width: 23
  },
  activitiesCreateBookingSelectedEventAddButton: {
    objectFit: "cover",
    height: 23,
    width: 23
  },

  activitiesCreateBookingCancellationPolicyContainer: {
    marginVertical: 12
  },
  activitiesCreateBookingCancellationPolicyTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none"
  },
  activitiesCreateBookingCancellationPolicySubDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none"

  },
  activitiesCreateBookingSelectHeading: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 8
  },
  activitiesCreateBookingSelectSubHeading: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  activitiesDynamicFormContainer: {
    gap: 8,
    marginVertical: 8
  },
  activitiesDynamicFormContainerText: {
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 8,
  },
  activitiesDynamicFormItemContainer: {
    gap: 8,
    marginTop: 8
  },
  activitiesDynamicFormItemContainerHeading: {
    marginVertical: 8,
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  activitiesAdditionlaDetailsTextCotainer: {
    // flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 8,

  },
  activitiesAdditionlaDetailsTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none"
  },
  activitiesAdditionlaDetailsTitleText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "none",
    // textAlign: "right"
  },
  activitiesBookingUpdateHeaderTitleContainer: {
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 0,
  },

  checkboxContainer: {
    // display: "flex",
    flexDirection: "row",
    gap: 8,
    alignItems: "center",
  },
  termnsAndConditionContainer: {
    flexDirection: "row",
  },
  checkboxContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  termsAndConditionCheckboxText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingLeft: 8,
  },
  termsAndConditionText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: "#0000EE"
  },

  activitiesCreateBookingHeaderContainer: {
    justifyContent: "center",
    alignItems: "center",

  },
  activitiesCreateBookingHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 12,
    textTransform: "none"
  },

  activitiesCreateBookingHeaderDescription: {
    ...FONT_MEDIUM,
    ...SECONDARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    // marginBottom: 18,
    textAlign: "center"
  },
  


  /**
 *
 * GUEST DETAILS WIDGET STYLE
 *
 */

  guestDetailsWidgetContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 8,
    padding: 16,
    backgroundColor: COLORS.PRIMARY_COLOR,
    // marginTop: 24
  },
  guestDetailsHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textTransform: "uppercase",
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center'
  },
  guestDetailsHeaderSubtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },
  guestDetailsImageStyle: {
    width: '100%',
    height: 230,
    margin: "auto",
    objectFit: 'contain',
    resizeMode: 'contain'
  },
  guestDetailsButtonContainer: {
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    width: "100%",
    paddingVertical: 8,
    gap: 12
  },
  guestDetailsButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  guestDetailsDateContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: 'space-between',
    marginVertical: 24,
    gap: 8,
  },
  guestDetailsDateItemContainer: {
    borderWidth: 0.5,
    borderColor: COLORS.ACCENT_COLOR,
    width: 100,
    paddingVertical: 16,
    paddingHorizontal: 10
  },
  guestDetailsDateItemDurationContainer: {
    flex: 1,
    width: "auto",
  },
  guestDetailsDateItemTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  guestDetailsDateItemSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  /**
   * Info Page Scroll Update
   */
  infoPageScrollWidgetsWidgetContainer:{
    paddingHorizontal: 0,
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 0,
    paddingVertical: 40,
    alignItems: "center",
  },
  infoPageScrollWidgetHeaderTitle:{

  },
  infoPageScrollWidgetHeaderSubtitle: {
    color: COLORS.SECONDARY_TEXT_COLOR,
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    position: 'absolute',
    bottom: 75,
    textAlign: "center",
    paddingHorizontal: 20,
    lineHeight: 24
  },
  infoPageScrollWidgetImageStyle:{
    height: 320,
    objectFit: 'cover',
    width: '100%',
  },
  infoPageScrollWidgetButtonContainer:{
    backgroundColor: "transparent",
    position: 'absolute',
    bottom: 85,
    borderBottomWidth: 2,
    borderColor: COLORS.WHITE,
  },
  infoPageScrollWidgetButtonContainerText:{
    color: COLORS.SECONDARY_TEXT_COLOR,
    ...SECONDARY_FONT,
    ...FONT_LARGE,
    // textDecorationLine: 'underline',
  },
  infoPageScrollMainContainerChildContainer:{
    top: -80,
    marginBottom: -50
  },
  infoPageScrollPaginationDot:{
    borderColor: COLORS.WHITE,
    height: 8,
    width: 8
  },
  infoPageScrollActivePaginationDot:{
    backgroundColor: COLORS.WHITE
  },


  /**
   * Guest Itinerary Style
   * 
   */
  guestitinerary_RootContainer: {
    flex: 1,
  },
  guestitinerary_MainContainerChildContainer: {
    flex: 1,
    flexDirection: "column",
    // padding: 16,
    gap: 10,
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  guestitinerary_MainContainerChildItem: {
    display: 'flex',
    flexDirection: "column",
    // paddingVertical: 16,
    // gap: 10,
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  guestitinerary_MainContainerChildItemHeaderTitle: {
    marginTop: 20,
    marginBottom: 12,
  },
  guestitinerary_MainContainerChildItemContainer: {
    borderLeftWidth: 5,
    borderLeftColor: COLORS.ACCENT_COLOR,
    paddingLeft: 12,
    justifyContent: 'center',
    height: 56
  },
  guestitinerary_MainContainerChildItemTitle:{
    paddingBottom: 10
  },

  guestItineraryMainContainerChildContainer: {
    backgroundColor: COLORS.WHITE,
    paddingHorizontal: 0,
    minHeight: 175,
    borderRadius: 10,
  },

  guestitinerary_HeaderTitleContainer: {
    paddingBottom: 8,
  },

  guestItineraryWidgetBookmarkIcon: {
    width: 24,
    height: 24
  },
  
  guestItineraryWidgetHeaderContainer: {
    marginTop: 0,
    alignItems: "center"
  },

  guestitinerary_HeaderTitle: {
    ...FONT_LARGE,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },


  guestItineraryWidgetMainContainerChildContainer: {
    paddingHorizontal: 0,
  },



  /**
   * Guest Itinerary Details
   */

  guestItineraryWidgetViewAllTxt: {
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  guestItineraryWidgetTitleText:{
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  guestItineraryWidgetSubTitleText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center",
    paddingVertical: 10
  },
  guestItineraryWidgetItemImageContainer: {
    height: 50,
    width: 50

  },
  guestItineraryWidgetItemImage: {
    objectFit: "cover",
    width: 50,
    height: 50,


  },
  guestItineraryWidgetTitleTextContainer:{
    width: "100%",
    paddingLeft: 10,
    paddingRight: 10,
    justifyContent: "center"
  },
  guestItineraryWidgetSubTitleText2: {
    paddingHorizontal: 17,
    textAlign: "center",
    paddingTop: 0,
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  guestItineraryViewAllButtonContainer: {
    marginVertical: 20,
  },

  

  guestItineraryWidgetRootContainer: {
    flex: 1,
    padding: 16,
    // maxHeight: 320,
  },
  guestItineraryWidgetTitleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.BACKGROUND_COLOR,
    flexDirection: "column",
    // position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 1,
    // height: 32,
    paddingVertical: 0,
    paddingHorizontal: 0
  },

  guestItineraryWidgetsWidgetContainer: {

  },
  guestItineraryWidgetHeaderTitle:{
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    marginTop: 20,
    marginBottom: 12,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  guestItineraryWidgetContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderLeftWidth: 5,
    borderLeftColor: COLORS.ACCENT_COLOR,
    paddingLeft: 12
  },
  guestItineraryWidgetImageStyle: {
    width: 72,
    height: 72,
  },
  guestItineraryWidgetImage: {
    width: "100%", 
    height: "100%"
  },
  guestItineraryWidgetTextContainer: {
    flex: 1,
    height: 72,
    justifyContent: "center"
  },
  guestItineraryWidgetTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 24
  },
  guestItineraryWidgetDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  guestItineraryWidgetArrow_container: {
    padding: 16
  },

  guestItineraryWidgetTitleViewAll: {
    display: 'none',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  guestItineraryWidgetTitleArrow: {

  },
  guestItineraryWidgetTitleArrow_container: {
    padding: 16,
    height: 48,
    width: 41
  },

  guestItineraryWidgetItemContainer: {
    flexDirection: "row",
    width: "75%"
  },


  guestItineraryDetails_timeDateContainer:{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    marginHorizontal: 16,
    marginBottom: 8,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  guestItineraryDetails_timeDateItem: {
    width: '50%',
    paddingVertical: 10
  },

  guestItineraryDetails_descriptionContainer: {
    display: 'flex',
    marginHorizontal: 16,
    marginBottom: 8,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  guestItineraryDetails_description: {
    paddingVertical: 10
  },
  guestItinerary_details:{
    marginBottom: 8,
  },
  guestItinerary_detailItem: {
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: 10,
    justifyContent: 'space-between',
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },

  /**
 *
 * Banner WIDGET STYLE
 *
 */
  bannerWidgetMainContainer: {
    flex: 1,
    paddingHorizontal: 16,
  },
  bannerWidgetsWidgetContainer: {
    flex: 1,
    flexDirection: "row",
    paddingVertical: 16,
    gap: 16,
    width: "100%",
    alignItems: "center",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  bannerWidgetImageStyle: {
    width: 72,
    height: 72,
  },
  bannerWidgetImage: {
    width: "100%", 
    height: "100%",
    objectFit: 'cover'
  },
  bannerWidgetTextContainer: {
    flex: 1,
    minHeight: 72,
    maxHeight: 90,
    justifyContent: "center"
  },
  bannerWidgetTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 24
  },
  bannerWidgetDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  bannerWidgetArrow_container: {
    padding: 16
  },

/**
 * Spa booking - book4time
 */
  spaBookingHeaderImg: {
    height: 292,
    maxWidth: null,
    margin: null
  },

  spaBookingMakeReservationContianer: {
    paddingVertical: 8,
    paddingHorizontal: 32,
    marginBottom: 40,
    height: 56,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  spaBookingMakeReservation: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textTransform: "uppercase",
  },

  spaBookingMyReservationHeading: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },

  spaBookingNoReservationErrorContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 24,
    marginTop: 16,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.10)",
  },
  spaBookingNoReservationError: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  spaBookingItemContainer: {
    height: "auto",
  },


  // Spa Booking 1a
  spaBookingMainContainerChildContainer: {
    marginBottom: 180,
  },

  spaBookingFitlerContainer: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    marginBottom: 0
  },
  spaBookingFitlerButtonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderBottomWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.10)"
  },
  spaBookingFitlerButtonText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  spaBookingFitlerButtonContainerSelected: {
    borderBottomWidth: 2,
    borderColor: COLORS.ACCENT_COLOR
  },
  spaBookingFitlerButtonTextSelected: {
    color: COLORS.ACCENT_COLOR
  },
  spaBookingHeaderTitleImage: {
    height: 24,
    width: 24,
  },
  spaBookingEditButton: {
    height: 20,
    width: 20,
    objectFit: "cover"
  },
  spaBookingNextButtonContainer: {
    bottom: 0,
     width: '100%',
     position: 'absolute',
     padding: 16,
     backgroundColor: COLORS.BACKGROUND_COLOR,
     gap: 10,
  },


  spaBooking1aListItemName: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingTop: 40,
    paddingBottom: 12,
    textAlign: "center",
    textTransform: "uppercase"
  },
  spaBooking1aOnlineListItemDetailsName: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBooking1aOnlineListItemDetailsDescription: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  spaBooking1aOnlineListItem: {
    display: "flex",
    // justifyContent: "center",
    flexDirection: "row",
    gap: 16,

  },
  spaBooking1aOnlineListItemCheckbox: {
    borderRadius: 10,
  },
  spaBooking1aOnlineListItemDetails: {
    width: "100%",
    gap: 8,
    height: "auto"
  },
  spaBooking1aOnlineListItemDetailsContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  spaBooking1aOfflineListItem: {
    height: "auto"
  },
  spaBooking1aListItemElseContainer: {
    height: "auto"
  },

  spaBooking1aOnlineListItemDetailsMinutes: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBooking1aOnlineListItemDetailsPrice: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  spaBooking1aOfflineListItemName: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBooking1aOfflineListItemDescription: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
    paddingBottom: 8,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },

  spaBooking1aOfflineListItemContactLabel: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBooking1aOfflineListItemDetails: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  spaBooking1aOfflineListItemDetailsContainer: {
    height: "auto"
  },


  // 2a
  spaBookingTopContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 24,
  },
  spaBookingDurationContainer: {
    gap: 8
  },
  spaBookingBaseContainer: {
    gap: 8,
  },
  spaBookingDurationTtitleText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    // marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingBasePriceTitleText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    // marginBottom: 8,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingBasePriceText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingDurationText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingAddOnListHeading: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    // width: 120,
    textTransform: "uppercase"
  },
  spaBookingAddOnListSubHeading: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginVertical: 12,
  },
  spaBookingAddOnListItemAddonsContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 16,
  },
  spaBookingAddOnListItemAddonsContainerName: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: "100%",
  },
  spaBookingAddOnListItemAddonsContainerPrice: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: 120
  },
  spaBooking2aTherapistContainerTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: 120,
    textTransform: "uppercase"
  },
  spaBookingDataContainerLabel: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    // width: 120,
    textTransform: "uppercase"
  },
  spaBooking2aTherapistContainer: {
    marginTop: 24
  },  

  spaBookingDateContainer: {
    marginTop: 24,
  },
  spaBookingDropdownContainer: {
    display: "none",
    marginTop: 24
  },
  spaBookingTechnicalDataTitle:{
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    // width: 120,
    textTransform: "uppercase"
  },
  spaBookingTechnicalDataListItemStartime:{
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingTechnicalDataListItemTechnicianName:{
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    display: "none"
  },

  // 2c
  spaBooking2cInputContainer: {
    gap: 12
  },
  spaBookingDetailsTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    display: "none"
  },
  spaBookingSummaryListItem: {
    justifyContent: "space-between"
  },
  spaBookingSummaryListItemLeftText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    maxWidth: "45%",
  },
  spaBookingSummaryListItemRightText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: "50%"
  },

  spaBookingTechnicalDetailsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  spaBookingTechnicalDetailsTimeContainer: {
    width: "50%",
    gap: 8

  },
  spaBookingTechnicalDetailsTimeTitle: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  spaBookingTechnicalDetailsTimeText: {
    ...PRIMARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  // spa success
  spaBookingSuccessText: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },




  /**
 *
 * Multiple LARGE WIGDET
 *
 */
  multipleLargeWidgetContainer: {
    flex: 1,
    backgroundColor: COLORS.PRIMARY_COLOR,
    paddingLeft: 16,
    paddingVertical: 24,
  },
  multipleLargeWidgetTitleContainer: {
    display: 'flex',
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingRight: 16
  },
  multipleLargeWidgetTitleText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    width: "100%",
  },
  multipleLargeWidgetTextContainer:{
    maxWidth: "80%"
  },
  multipleLargeWidgetDescriptionText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 8
  },

  multipleLargeWidgetViewAllTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  multipleLargeWidget_MainWidgetsContainer: {
    display: "flex",
    gap: 16,
    alignItems: "flex-start",
    paddingRight: 16,
    marginTop: 16
  },
  multipleLargeWidget_WidgetsContainer: {
    display: "flex",
    flexDirection: "column",
    width: 175,
    gap: 16,
    alignSelf: "stretch"
  },
  multipleLargeWidget_WidgetsImg: {
    width: "100%",
    height: 260,
    alignSelf: "stretch",
    objectFit: "cover"
  },
  multipleLargeWidget_WidgetsTitleContainer: {
    position: "absolute",
    bottom: 0,
    padding: 16,
    gap: 10,

    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignSelf: "stretch"
  },
  activitiesCreateBookingTimeSlotsItemText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  activitiesCreateBookingSelectedEventQuantity: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  multipleLargeWidget_WidgetsTitleText: {
    width: "100%",
    ...PRIMARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.WHITE
  },
  multipleLargeWidget_WidgetsSubTitleText: {
    width: "100%",
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.WHITE
  },
  multipleLargeWidget_WidgetsButtonContainer: {
    display: "flex",
    justifyContent: "center",
    paddingVertical: 4,

    height: 22,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.ACCENT_COLOR,
    width: 100
  },
  multipleLargeWidget_WidgetsButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.ACCENT_COLOR
  },
  multipleLargeWidget_WidgetsButtonContainerTextArrow: {
    height: 8,
    width: 25,
  },

  /* MULTIPLE SMALL WIDGET */
  multipleSmallWidgetContainer: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    paddingLeft: 16,
    paddingVertical: 40,
  },
  multipleSmallWidgetTitleContainer: {
    display: 'flex',
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingRight: 16
  },
  multipleSmallWidgetTitleText: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.SECONDARY_TEXT_COLOR,
  },
  multipleSmallWidgetViewAllTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR,
  },
  multipleSmallWidget_MainWidgetsContainer: {
    display: "flex",
    gap: 24,
    alignItems: "flex-start",
    paddingRight: 16,
    marginTop: 24
  },
  multipleSmallWidgetTitleTextContainer: {
    maxWidth: "80%",
  },
  multipleSmallWidgetDescriptionText:{
    ...SECONDARY_FONT,
    ...FONT_LARGE,
    colors: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 16
  },
  multipleSmallWidget_WidgetsContainer: {
    display: "flex",
    flexDirection: "column",
    width: 300,
    height: 300,
    gap: 16,
    alignSelf: "stretch"
  },
  multipleSmallWidget_WidgetsImg: {
    width: "100%",
    height: 300,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignSelf: "stretch"
  },
  multipleSmallWidget_WidgetsTitleContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    gap: 16,
    padding: 24,
    alignSelf: "stretch"
  },
  multipleSmallWidget_WidgetsTitleText: {
    width: "100%",
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.SECONDARY_TEXT_COLOR
  },
  multipleSmallWidget_WidgetsSubTitleText: {
    width: "100%",
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR
  },
  multipleSmallWidget_WidgetsButtonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    height: 48,
    width: "50%",
    paddingHorizontal: 24,
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: COLORS.SECONDARY_TEXT_COLOR
  },
  multipleSmallWidget_WidgetsButtonContainerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR
  },

  /** 
   * iFrameViewer
  */

  iFrameRootContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    overflow: 'hidden',
  },
  iFrameMainContainer: {
    flex: 1,
    overflow: "hidden",
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    overflow: "hidden",
    backgroundColor: COLORS.BACKGROUND_COLOR,
    flex: 1,
    paddingHorizontal: 16
  },
  iFrameMainContainerChildContainer: {
    height: "100%",
    paddingHorizontal: 0,
  },

  webViewMainContainerChildContainer: {
    flex: 1,
  },
  iFrameHeaderContainer: {
    display: "none"
  },

  /** 
   * iFrameViewer Open Default
  */

  iFrameRendererHomeMainContainer: {
    zIndex: 1000,
    overflow: 'hidden',
    minHeight: 300
  },

  iFrameRendererHomeMainContainerChildContainer: {
    width: '100%',
    height: '100%',
    border: 'none',
  },

  webViewHomeMainContainerChildContainer: {
    flex: 1,
  },


  /**
   *
   * Sub Widget List View
   *
   */
  subwidgetListRootContainer: {

  },
  subwidgetListMainContainer: {

  },
  subwidgetListHeaderContainer: {

  },
  subwidgetListHeaderImg: {

  },
  subwidgetListHeaderTitleContainer: {

  },
  subwidgetListHeaderTitle: {

  },
  subwidgetListHeaderSubTitle: {

  },
  subwidgetListMainContainerChildContainer: {

  },
  subwidgetList_itemContainer: {

  },
  subwidgetList_itemContainer_image: {

  },
  subwidgetList_itemContainer_textContainer: {

  },
  subwidgetList_itemContainer_textContainer_title: {

  },
  subwidgetList_itemContainer_textContainer_subtitle: {

  },
  subwidgetList_itemContainer_arrow: {

  },

  /**
   * Client Config Change Modal
   */


  changeConfigModalMainContainer: {
    gap: 16,
  },



  /**
   *
   * HEADER
   *
   */
  safeArea: {
    paddingTop: Platform.OS === "android" ? StatusBar.currentHeight : 0,
  },
  headerContainer: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  headerContainerInner: {
    display: "flex",
    flexDirection: "row",
    height: 56,
    width: "100%",
    justifyContent: 'center',
    alignItems: "center",
    gap: 8,
    padding: 8,
  },
  headerContainerInnerCompLeft: {
    display: "flex",
    height: 32,
    justifyContent: "center",
    alignItems: "flex-start",
    gap: 4,
    paddingHorizontal: 8,
    flex: 1
  },
  backIconContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  backIcon: {
    display: "flex",
    height: 18,
    width: 18,
    justifyContent: "center",
    alignItems: 'center',
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  backText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  locationIconContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  locationIcon: {
    display: "flex",
    height: 18,
    width: 18,
    justifyContent: "center",
    alignItems: 'center',
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  locationText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  headerContainerLogoContainer:{

  },
  headerContainerLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: "center",
    width: 118,
    height: 32
  },
  headerContainerInnerCompRight: {
    display: "flex",
    height: 32,
    justifyContent: "center",
    alignItems: "flex-end",
    gap: 4,
    paddingHorizontal: 8,
    flex: 1
  },

  headerBackContainer_background_gradient: {

  },

  notificationIcon: {
    display: "flex",
    height: 20,
    width: 20,
    justifyContent: "center",
    alignItems: 'center',
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  notificationicon_countcontainer: {
    display: "flex",
    position: "absolute",
    top: -12,
    right: -10,
    backgroundColor: COLORS.BLACK,
    width: 24,
    height: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignitems: "center"
  },
  notificationicon_countcontainer_text: {
    color: COLORS.WHITE,
    textAlign: "center"
  },
  notificationicon_countcontainer_unread: {
    display: "flex",
    position: "absolute",
    top: -12,
    right: -12,
    backgroundColor: "#DC4538",
    width: 24,
    height: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignitems: "center"
  },
  notificationicon_countcontainer_unread_text: {
    color: COLORS.WHITE,
    textAlign: "center"
  },



  /* buttons */

  footer_button_container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    gap: 16,
    padding: 24,
    alignItems: "flex-start",
    backgroundColor: COLORS.PRIMARY_COLOR
  },


  primaryBtn: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    display: "flex",
    flexDirection: "row",
    minHeight: 56,
    width: '100%',
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,

    elevation: 2,

    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  primaryBtnTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: 'uppercase',
    color: COLORS.SECONDARY_TEXT_COLOR,
    margin: "auto"
  },
  primaryBtn_loader: {

  },

  secondaryBtn: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    display: "flex",
    flexDirection: "row",
    minHeight: 56,
    width: '100%',
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 0.5,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    borderRadius: 10,

    elevation: 0.5,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  secondaryBtnTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: 'uppercase',
    color: COLORS.PRIMARY_TEXT_COLOR,
    margin: "auto"
  },

  tertiaryBtn: {
    display: "flex",
    flexDirection: "row",
    minHeight: 56,
    width: '100%',
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1.5,
    borderColor: COLORS.SECONDARY_COLOR,
    borderRadius: 10,

    elevation: 0.5,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  tertiaryBtnTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: "uppercase",
    color: COLORS.SECONDARY_COLOR,
    margin: "auto"
  },

  appleWalletBtn: {
    backgroundColor: COLORS.BLACK,
    display: "flex",
    flexDirection: "row",
    minHeight: 56,
    width: 256,
    marginHorizontal: "auto",
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 0.5,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    borderRadius: 10,

    elevation: 0.5,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  appleWalletBtnLogo: {
    width: 46, 
    height: 33, 
    resizeMode: "contain"
  },
  appleWalletBtnTxt: {
    color: COLORS.WHITE,
    fontFamily: "SF Pro",
    fontSize: 19,
    fontWeight: 400,
    textAlign: "center",
    margin: "auto"
  },


  /* Cross Button */

  crossOverContainer_Container: {
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: 1,
  },
  crossOverContaniner_Cross: {
    borderRadius: 50,
    backgroundColor: COLORS.BLACK,
    padding: 4,
    marginRight: 16,
    alignSelf: 'flex-end',
    marginTop: 10,
  },
  crossOverContaniner_loader: {
    tintColor: COLORS.BLACK
  },


  /* Slider Pressable */
  customSliderContainer: {
    width: "100%",
    height: 50,
    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    cursor: "pointer",
  },
  customSliderFill: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    zIndex: 0,
    backgroundColor: COLORS.ACCENT_COLOR,
  },
  customSliderFillAnimated: {
    backgroundColor: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  customSliderText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  customSliderThumb: {
    width: 50,
    height: 50,
    borderRadius: 10,
    backgroundColor: COLORS.WHITE,
    position: 'absolute',
    left: 0,
    top: 0,
    justifyContent: 'center',
    alignItems: 'center',

    elevation: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },
  customSliderArrowIcon: {
    width: 24,
    height: 12,
    objectFit: "contain"
  },


  /* Chip */
  chipContainer: {
    width: 200,
    maxWidth: 250,
    height: 40,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    margin: "auto",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
  },

  chipContainerText: {
    ...FONT_XSMALL,
    ...SECONDARY_FONT,
    color: COLORS.WHITE,
    textAlign: "center"
  },


  /**
*
* DATA FETCHING VIEW
*
*/
  overlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    gap: 24,
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  },
  overlayContainer_loader: {

  },
  overlayContainer_message: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.WHITE,
  },


  /* Input */

  textContainer: {
    gap: 8
  },
  input: {
    height: 56,
    padding: 16,
    width: "100%",
    color: COLORS.PRIMARY_TEXT_COLOR,
    borderWidth: 0.5,
    borderRadius: 10,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    backgroundColor: COLORS.PRIMARY_COLOR,
    selectionColor: COLORS.ACCENT_COLOR,
    outlineWidth: 0,
    elevation: 0.5,
    // iOS shadow styles
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.1,
    shadowRadius: 6,
  },
  label: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: "capitalize",
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  errorText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: 'red',
  },

  /* Required Text */
  requiredText: {
    color: 'red',
  },


  /* Dropdown */

  dropdownMaincontainer: {
    display: "flex",
    width: "100%",
    gap: 8,
    zIndex: 100
  },


  /* Dropdown - web */

  dropdown_web: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    width: "100%",
    minHeight: 56,
    padding: 16,
    borderWidth: 0.5,
    borderRadius: 10,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },

  dropdown_web_container: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    lineHeight: null,
    color: COLORS.PRIMARY_TEXT_COLOR,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  dropdown_web_container_selected: {
    backgroundColor: "#F6F7F8",
    borderRadius: 10,
  },

  /* Dropdown - native */
  dropdown: {
    width: "100%",
    minHeight: 56,
    padding: 16,
    borderWidth: 0.5,
    borderRadius: 10,
    borderColor: COLORS.PRIMARY_TEXT_COLOR,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  dropdown_container: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderRadius: 10,
  },
  dropdown_placeholder: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: "gray",
  },
  dropdown_selectedTextStyle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  dropdown_headerContainer: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderRadius: 10,
    paddingVertical: 8,
    paddingHorizontal: 10,
  },
  dropdown_headerText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: "bold",
  },
  dropdown_itemContainerStyle: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderRadius: 10,
    paddingVertical: 4,
    paddingHorizontal: 10,
  },
  dropdown_itemTextStyle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  dropdown_inputsearchstyle: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    color: COLORS.PRIMARY_TEXT_COLOR,
    borderRadius: 10
  },


  /* Pagination */
  paginationContainer: {
    display: "flex",
    flexDirection: "row",
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    gap: 6,
    alignSelf: "stretch"
  },
  paginationDot: {
    width: 12,
    height: 12,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: COLORS.SECONDARY_COLOR
  },
  paginationActiveDot: {
    backgroundColor: COLORS.SECONDARY_COLOR
  },


  /* Custom modal */
  customModalContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100%",
    zIndex: 2
  },
  customModalInnerContainer: {
    flex: 1,
    width: "100%",
    margin: "auto",
    justifyContent: "flex-end",
    maxWidth: GENERAL_MAX_WIDTH,
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "flex-end",
  },

  /* Custom Overlay */
  customOverlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    gap: 24,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  },


  /* Date picker modal */
  datePickerModaContainer: {
    flex: 1,
    width: "100%",
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: "auto",
  },
  datePickerWrapper: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingBottom: 24,
    width: '100%',
    maxWidth: GENERAL_MAX_WIDTH,
  },
  datePickerWrapper_child: {
    maxWidth: GENERAL_MAX_WIDTH_SECONDARY,
    marginHorizontal: "auto"
  },
  datePickerWrapper_child_innerContainer: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  DateTimePicker_primaryTextStyle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  DateTimePicker_secondaryTextStyle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  DateTimePicker_selectedTextStyle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    backgroundColor: COLORS.SECONDARY_COLOR,
    color: COLORS.SECONDARY_TEXT_COLOR
  },


  /* Flash Message */
  flashMessageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 56,
    gap: 8
  },
  flashMessageContainerDefault: {
    backgroundColor: COLORS.PRIMARY_COLOR
  },
  flashMessageContainerSuccess: {

  },
  flashMessageContainerError: {

  },

  flashMessageContainer_text: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM
  },
  flashMessageContainer_textDefault: {
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  flashMessageContainer_textSuccess: {

  },
  flashMessageContainer_textError: {

  },

  flashMessageContainer_title: {
    ...PRIMARY_FONT,
    ...FONT_MEDIUM
  },
  flashMessageContainer_titleDefault: {
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  flashMessageContainer_titleSuccess: {

  },
  flashMessageContainer_titleError: {

  },

  /* Auto Login Success Modal */
  autoLoginCardContainer : {
    flex: 1,
    width: "100%",
    maxHeight: 400,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 40,
    flexDirection: "column",
    justifyContent: "center",
    gap: 8
  },
  autoLoginSuccessContainer: {
    display: 'none'
  },
  autoLoginCardHeader: {
  },
  autoLoginCardHeaderText: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    textAlign: "center",
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  autoLoginCardBodyLoginText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  autoLoginGenericDoorkeyText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginVertical: 10,
  },
  autoLoginGenericDoorkeyImage: {
    width: 20,
    height: 20,
    marginHorizontal: 5,
    resizeMode: 'contain',
  },
  autoLoginCardBody: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    paddingVertical: 10,
    gap: 10,
  },
  autoLoginCardBodyTextContainer: {
    flex: 1,
    marginTop: 0,
  },
  autoLoginSuccessContainerBackgroundImg: {
    width: 50,
    height: 50,
    filter: "invert(1)",
    tintColor: COLORS.PRIMARY_TEXT_COLOR,
    resizeMode: 'contain',
    marginLeft: 10,
  },
  



  /* Info Modal Container */

  infoModalContainer: {
    display: "flex",
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    flexDirection: "column",
    justifyContent: "center",
    gap: 8
  },
  infoModalLoader: {
    tintColor: COLORS.BLACK,
  },
  infoModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingVertical: 8
  },
  infoModalSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
    paddingVertical: 8
  },
  infoModalSuccessContainer: {
    width: "100%",
    margin: "auto",
    padding: 0,
    justifyContent: "center",
    alignItems: 'center'
  },
  infoModalSuccessContainerBackgroundImg: {
    width: 70,
    height: 70,
    filter: "invert(1)",
    tintColor: COLORS.PRIMARY_TEXT_COLOR
  },



  // BookingFound Modal
  bookingFoundModalContainer: {
    display: "flex",
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    flexDirection: "column",
    justifyContent: "center",
    gap: 8
  },
  bookingFoundModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingTop: 8
  },
  bookingFoundModalSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
    paddingBottom: 8
  },
  bookingFoundModalButtonContainer: {
    flexGrow: 1, 
    justifyContent: "flex-end", 
    alignItems: "center",
    gap: 12
  },


  // Logout Modal

  logoutModalContainer: {
    display: "flex",
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    flexDirection: "column",
    justifyContent: "center",
    gap: 8
  },
  logoutModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingVertical: 8
  },
  logoutModalButtonContainer: {
    flexGrow: 1, 
    justifyContent: "flex-end", 
    gap: 12
  },



  // Admin Panel Modal

  adminPanelModalContainer: {
    flex: 1,
    maxHeight: 720,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    gap: 16
  },
  adminPanelModalChildContainer: {
    flex: 1,
    gap: 16
  },
  adminPanelModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    paddingVertical: 8
  },
  adminPanelModalButtonContainer: {
    flexGrow: 1, 
    justifyContent: "flex-end", 
    gap: 12
  },

  /*
  *
  *
  * LOGIN MODAL
  *
  */
  loginModalContainerOverlay: {
    flex: 1,
    justifyContent: "flex-end",
  },
  loginModalContainer: {
    flex: 1,
    maxHeight: 720,
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    gap: 16
  },
  LoginModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    paddingVertical: 8
  },
  LoginModalSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center",
    paddingBottom: 8
  },
  LoginModalDisclaimerContainer: {
    backgroundColor: COLORS.ACCENT_COLOR,
    paddingVertical: 16,
    paddingHorizontal: 24,
  },
  LoginModalDisclaimerText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.ACCENT_Text_COLOR,
    textAlign: "center"
  },
  LoginModalVersionText: {
    position: "fixed", 
    bottom: 1, 
    left: 0, 
    right: 0,
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },
  loginModalBottomTxt: {
    display: 'none',
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "center"
  },
  loginModalButtonContainer: {
    flexGrow: 1, 
    justifyContent: "flex-end", 
    gap: 12
  },

  // Guest List
  otpPinContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 35,
    marginHorizontal: 16,
  },
  guestListItemContainer: {
    marginBottom: 16
  },
  guestListItemTitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: "capitalize",
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  horizontalline: {
    display: "none"
  },
    /**
   * Parallac Scroll View
   */

  parallaxScrollViewContainer: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  parallaxScrollViewHeaderContainer: {
    position: 'absolute',
    height: 393,
    zIndex: -1,
    overflow: 'hidden',
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  parallaxScrollViewChildContainer: {
    // paddingTop: 393,
  },
  parallaxRootContainer: {
    flex: 1,
  },
  parallaxRootContainerHeaderContainer: {
    overflow: 'hidden',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: -1,
  },


  /* Progress Bar */
  progressBarModalContainer: {
    display: "flex",
    width: "100%",
    alignItems: 'center',
    justifyContent: 'center',
    padding: 32,
    gap: 8,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  progressBarContainer_title: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingVertical: 8
  },
  progressBarContainer: {
    display: 'flex',
    width: "100%",
    paddingVertical: 8,
  },
  progressBar: {
    position: "absolute",
    width: "100%",
    height: 15,
    borderWidth: 2,
    borderRadius: 50,
    borderColor: "rgba(0,0,0,0.2)",
    overflow: "hidden"
  },
  progressBarInnerContainer: {
    width: "100%",
    height: "100%",
    borderWidth: 2,
    borderColor: COLORS.BACKGROUND_COLOR,
  },
  progressBarAnimateContainer: {
    position: "absolute",
    bottom: 0,
    height: "100%",
    borderRadius: 50,
  },
  colorInterpolateProgressBar: {
    inputRange: [0, 100],
    outputRange: [COLORS.SECONDARY_COLOR + "55", COLORS.SECONDARY_COLOR]
  },


  /**
   *
   * INITIAL LOADER SCREEN
   */

  preLoaderContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 10000,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  preLoader_Loader: {

  },
  preLoader_Loaderlottie: {
    flex: 1, 
    width: '100%', 
    height: '100%'
  },
  

  /** WelcomeScreen **/
  welcomeScreenContainer: {
    flex: 1,
    width: "100%",
    justifyContent: 'flex-end',
    paddingTop: 0,
    paddingBottom: 24,
    gap: 24,
  },
  welcomeScreenVideo: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: isWeb() ? "100%" : null,
    height: isWeb() ? "100%" : null,
    objectFit: "cover"
  },
  welcomeScrLogoContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: "absolute",
    height: "100%",
    width: "100%",
    top: -100,
    zIndex: 2
  },

  welcomeScrTopLogoContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: "absolute",
    width: "100%",
    top: 45,
    zIndex: 2
  },
  welcomeScreenTopLogoStyle: {
    width: 107,
    height: 60
  },
  welcomeScreenLogoLottie: {
    flex: 1,
    width: "100%",
    height: "100%",
  },
  welcomeScreenLogoStyle: {
    width: 205,
    height: 143,
  },
  welcomeScreenLogoText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
  },
  welcomeScreenContent: {
    flex: 1,
    maxHeight: 340,
    // backgroundColor: COLORS.PRIMARY_COLOR,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingTop: 40,
    paddingBottom: 48,
    paddingHorizontal: 32,
    // gap: 16,
    justifyContent: 'flex-end'
  },
  welcomeScreenTertiaryBtn: {
    marginBottom: 24,
    alignItems: "center"
  },
  welcomeScreenHeaderTxtCont: {
    display: "none"
  },
  welcomeScreenBottomTxtCont: {
    marginBottom: 24,
  },
  welcomeScreenHeaderTxt: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textAlign: "center",
  },
  welcomeScreenBottomTxt: {
    ...SECONDARY_FONT,
    ...FONT_XSMALL,
    textAlign: 'center',
    color: COLORS.SECONDARY_TEXT_COLOR
  },
  welcomeScreenBottomLoginContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 4,
    marginBottom: 24,
  },
  welcomeScreenPrimaryBtn: {
    marginBottom: 8,
    alignItems: "center",
  },
  welcomeScreenBottomLoginTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textAlign: 'center',
    color: COLORS.SECONDARY_TEXT_COLOR
  },
  welcomeScreenBottomLoginBtnTxt: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.SECONDARY_TEXT_COLOR,
    textDecorationLine: "underline"
  },

  welcomeScreenOverlay: {
    display: "none",
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    zIndex: 1,
  },



  /* Widget HomePage Container */
  widgetRootContainer: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  widgetmainContainer: {
    flexGrow: 1,
  },
  widgetmainContainerHeaderContainer: {
    display: "flex",
    justifyContent: 'center',
    width: "100%"
  },
  widgetmainContainerHeaderImg: {
    width: "100%",
    height: 262,
    maxWidth: 1000,
    margin: "auto",
    objectFit: 'cover',
  },
  widgetmainContainerHeaderTitleContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    gap: 16,
    paddingVertical: 32,
    paddingHorizontal: 16
  },
  widgetmainContainerHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textTransform: "uppercase",
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  widgetmainContainerHeaderSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    paddingHorizontal: 24,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  widgetmainContainerHeaderSubTitle2: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    paddingHorizontal: 24,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  widgetmainContainerChildContainer: {
    flex: 1,
    paddingHorizontal: 16
  },

  /* List Component */

  list_itemContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    gap: 16,
    width: "100%",
    backgroundColor: COLORS.PRIMARY_COLOR,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  list_itemContainer_image: {
    width: 72,
    height: 72,
  },
  list_itemContainer_textContainer: {
    flex: 1,
    height: 72,
    justifyContent: 'center'
  },
  list_itemContainer_textContainer_title: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 24
  },
  list_itemContainer_textContainer_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  list_itemContainer_textContainer_tertiaryContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 8
  },
  list_itemContainer_arrow: {
    padding: 16
  },



  /* Widget Skeleton */

  widgetSkeletonRootContainer: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 1000,
    backgroundColor: COLORS.WHITE
  },
  widgetSkeletonMainContainer: {

  },
  widgetSkeletonHeaderContainer: {

  },
  widgetSkeletonHeaderImg: {
    maxWidth: null
  },
  widgetSkeletonMainContainerChildContainer: {

  },
  widgetSkeleton_itemContainer: {

  },
  widgetSkeleton_itemContainer_image: {

  },
  widgetSkeleton_itemContainer_textContainer: {
    gap: 8
  },
  widgetSkeleton_itemContainer_textContainer_title: {
    width: "100%"
  },
  widgetSkeleton_itemContainer_textContainer_subtitle: {

  },

  /**
 *
 * HOTEL LIST WIDGET
 *
 */
  hotelListWidgetRootContainer: {

  },
  hotelListWidgetMainContainer: {

  },
  hotelListWidgetHeaderContainer: {

  },
  hotelListWidgetHeaderImg: {
    objectFit: 'cover'
  },
  hotelListWidgetHeaderTitleContainer: {

  },
  hotelListWidgetHeaderTitle: {

  },
  hotelListWidgetHeaderSubTitle: {

  },
  hotelListWidgetMainContainerChildContainer: {

  },
  hotelListWidgetChildContainer: {
    gap: 16,
    paddingVertical: 16
  },
  hotelListWidgetChildContainerTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hotelListWidgetChildContainer_items_container: {

  },

  hotelListWidgetChildContainer_itemContainer: {

  },
  hotelListWidgetChildContainer_itemContainer_highlight:{
    backgroundColor: COLORS.LIGHT_GREY,
  },
  hotelListWidgetChildContainer_itemContainer_master: {
    display: "none"
  },
  hotelListWidgetChildContainer_itemContainer_image: {

  },
  hotelListWidgetChildContainer_itemContainer_textContainer: {

  },
  hotelListWidgetChildContainer_itemContainer_textContainer_title: {

  },
  hotelListWidgetChildContainer_itemContainer_textContainer_subtitle: {

  },
  hotelListWidgetChildContainer_itemContainer_arrow: {

  },

  hotelListErrorContainer: {
    width: "90%",
    display: "flex",
    justifyContent: "center",
    alignSelf: "flex-start",
    alignItems: "center",
    borderWidth: 1,
    padding: 32,
    marginBottom: 32,
    marginHorizontal: "auto",
    backgroundColor: COLORS.PRIMARY_COLOR
  },
  hotelListErrorContainerText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  /* 
    Selfie Tip Overlay
  */

  selfieTipOverlay: {
    position: "absolute",
    justifyContent: "center",
    width: "100%"
  },
  selfieTipIcon: {
    height: 20,
    width: 25
  },
  selfieTipText: {
    color: COLORS.SECONDARY_TEXT_COLOR,
  },

  selfieTipTextContainer:{
    position: "absolute",
    top: height * 0.22,
    left: "50%",
    bottom: 0,
    transform: [{ translateX: -100 }],
  },
  infoIcon: {
    height: 25,
    width: 25
  },
  instructionText: {
    color: COLORS.SECONDARY_TEXT_COLOR,
  },
  instructionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingTop: 20,
    paddingHorizontal: 40,
    gap: 5
  },

  selfieTipOverlayArrows: {
    borderWidth: 0,
    position: "relative",
    alignSelf: 'center',
    overflow: 'hidden',
    maxWidth: "80%"
  },


  selfieTipOverlayBG: {
    position: "absolute", 
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0, 
    width: width, 
    height: height, 
    opacity: 0.5,
    maxWidth: GENERAL_MAX_WIDTH
  },

  selfieTipOverlayImage: {
    position: "absolute", 
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0, 
    width: width, 
    height: height,
    maxWidth: GENERAL_MAX_WIDTH
  },

  /* Picture Preview */

  picturePreviewRootContainer: {

  },
  picturePreviewMainContainer: {

  },
  picturePreviewHeaderContainer: {

  },
  picturePreviewHeaderImg: {
    height: "auto",
    minHeight: 343,
    maxHeight: 343
  },
  picturePreviewMainContainerChildContainer: {

  },
  picturePreviewMainContainerChildContainer_textContainer: {
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 16
  },
  picturePreviewMainContainerChildContainer_textContainer_title: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  picturePreviewMainContainerChildContainer_textContainer_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  picturePreviewMainContainerChildContainer_buttonContainer: {
    gap: 8,
    paddingVertical: 16
  },


  cameraRootContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  cameraRootContainer_loader: {

  },
  captureButton: {
    zIndex: 100,
    position: 'absolute',
    bottom: 40,
    alignSelf: 'center',
    backgroundColor: COLORS.WHITE,
    width: 80,
    height: 80,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  captureButton_innerCircle: {
    borderWidth: 1,
    borderColor: COLORS.BLACK,
    width: 70,
    height: 70,
    borderRadius: 35,
  },

  id_instructionContainer: {
    flexDirection: 'row',
    position: 'absolute',
    bottom: 130,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    gap: 12
  },
  id_instructionInfoImage: {
    width: 24,
    height: 24,
    flexShrink: 0,
  },
  id_instructionText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: 'left',
    color: COLORS.WHITE
  },

  id_instructionOverlayContainer: {
    top: -70
  },
  id_instructionOverlayTop: {
    flex: 1, 
    backgroundColor: 'rgba(0,0,0,0.6)'
  },
  id_instructionOverlayMiddle: {
    flexDirection: 'row', 
    height: "65%"
  },
  id_instructionOverlayBottom: {
    flex: 1, 
    backgroundColor: 'rgba(0,0,0,0.6)'
  },

  id_instructionOverlayMiddleLeft: {
    flex: 1, 
    backgroundColor: 'rgba(0,0,0,0.6)'
  },
  id_instructionOverlayMiddleMiddle: {
    width: "80%", 
    backgroundColor: 'transparent'
  },
  id_instructionOverlayMiddleRight:{
    flex: 1, 
    backgroundColor: 'rgba(0,0,0,0.6)'
  },



  /**
 *
 * CheckInGuide
 */
  checkInGuideRootContainer: {

  },
  checkInGuideMainContainer: {
    // if you want to add maxWidth add that in this container
  },
  checkInGuideMainContainerHeaderContainer: {
    justifyContent: "space-between"
  },
  checkInGuideMainContainerHeaderImg: {
    height: 393,
    margin: null
  },
  checkInGuideMainContainerHeaderTitleContainer: {

  },
  checkInGuideMainContainerHeaderTitle: {

  },
  checkInGuideMainContainerHeaderSubTitle: {

  },
  checkInGuideMainContainerChildContainer: {

  },
  checkInGuideButtonContainer: {
    paddingVertical: 16,
    gap: 16
  },

  doorkeyGuideRootContainer: {

  },
  doorkeyGuideMainContainer: {

  },
  doorkeyGuideMainContainerHeaderImg: {

  },
  doorkeyGuideMainContainerHeaderTitleContainer: {

  },
  doorkeyGuideMainContainerHeaderTitle: {
    width: '100%'
  },
  doorkeyGuideMainContainerHeaderSubTitle: {

  },
  doorkeyGuideMainContainerHeaderContainer: {

  },
  doorkeyGuideMainContainerChildContainer: {
    marginBottom: 30
  },
  dookeyGuideButtonContainer: {
    paddingBottom: 16,
    gap: 16
  },
  //  Doorkey index.js
  doorkeyRootContainer: {

  },
  doorkeyMainContainer: {

  },
  doorkeyMainContainerHeaderTitleContainer: {

  },
  doorkeyMainContainerHeaderTitle: {

  },
  doorkeyMainContainerHeaderSubTitle: {

  },
  doorkeyMainContainerHeaderContainer: {

  },
  doorkeyMainContainerChildContainer: {
    alignItems: "center"
  },

  // OTP screen
  otpRootContainer: {

  },
  otpMainContainer: {

  },
  otpMainContainerHeaderTitleContainer: {

  },
  otpMainContainerHeaderTitle: {

  },
  otpMainContainerHeaderSubTitle: {

  },
  otpMainContainerHeaderContainer: {

  },

  /**
   * Offline Modal Container
   */
  offlineModalContainer:{
    flex: 1, 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  offlineModalTitle: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  offlineModalSubtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

  /**
 *
 * Booking Info
 */
  bookingInfoRootContainer: {

  },
  bookingInfoMainContainer: {

  },
  bookingInfoHeaderContainer: {

  },
  bookingInfoHeaderImg: {

  },
  bookingInfoHeaderTitleContainer: {

  },
  bookingInfoHeaderTitle: {

  },
  bookingInfoHeaderSubTitle: {

  },
  bookingInfoMainContainerChildContainer: {
    flex: 1,
    padding: 16,
    gap: 24
  },

  bookingInfoMainContainerChildContainer_infotext: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },

  /* ID Verification */
  verifyIdentityRootContainer: {

  },
  verifyIdentityMainContainer: {

  },
  verifyIdentityHeaderContainer: {

  },
  verifyIdentityHeaderTitleContainer: {

  },
  verifyIdentityHeaderTitle: {

  },
  verifyIdentityHeaderSubTitle: {

  },
  verifyIdentityMainContainerChildContainer: {
    gap: 24
  },
  verifyIdentityChildContainer_imageButtonContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    alignItems: "flex-start",
    width: "100%",
    marginHorizontal: "auto",
  },
  verifyIdentityChildContainer_imageButtonContainer_button: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingVertical: 12,
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    gap: 16,
    backgroundColor: COLORS.WHITE
  },
  verifyIdentityChildContainer_imageButtonContainer_buttonSelected: {
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  verifyIdentityChildContainer_imageButtonContainer_button_iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: "gray",
  },
  verifyIdentityChildContainer_imageButtonContainer_button_iconContainerSelected: {
    backgroundColor: COLORS.PRIMARY_COLOR
  },
  verifyIdentityChildContainer_imageButtonContainer_button_icon: {
    width: 20,
    height: 20,
    flexShrink: 0,
    tintColor: COLORS.BLACK,
    filter: "invert(1)"
  },
  verifyIdentityChildContainer_imageButtonContainer_button_iconSelected: {
    tintColor: COLORS.PRIMARY_TEXT_COLOR,
    filter: "invert(1)"
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer: {
    flex: 1,
    gap: 4
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer_title: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BLACK
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer_titleSelected: {
    color: COLORS.SECONDARY_TEXT_COLOR
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BLACK
  },
  verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitleSelected: {
    color: COLORS.SECONDARY_TEXT_COLOR
  },
  verifyIdentityChildContainer_imageButtonContainer_button_chevron: {
    tintColor: COLORS.BLACK,
  },
  verifyIdentityChildContainer_imageButtonContainer_button_chevronSelected: {
    tintColor: COLORS.SECONDARY_TEXT_COLOR,
    filter: "invert(1)"
  },
  verifyIdentityChildContainer_infoText: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },
  verifyIdentityChildContainer_buttonContainer: {
    paddingVertical: 16,
    gap: 8
  },

  idVerificationSuccessContainerHeaderImgContainer: {
    width: "100%",
    maxWidth: 1000,
    margin: "auto",
    padding: 28,
    paddingTop: 40,
    justifyContent: "center",
    alignItems: 'center',
    height: 392
  },
  idVerificationSuccessContainerHeaderImg: {
    height: 154,
    width: 154,
    tintColor: COLORS.SECONDARY_TEXT_COLOR,

    filter: "brightness(0) saturate(100%)",
  },

  idVerificationSuccessCheckIconContainer: {
    flexDirection: "row",
    gap: 24
  },
  idVerificationSuccessCheckIcon: {
    height: 24,
    width: 24
  },
  idVerificationSuccesspreCheckInHeaderTitleContainer: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  idVerificationSuccessCheckIcon1: {
    height: 24,
    width: 24,

    backgroundColor: COLORS.SECONDARY_COLOR,
    borderRadius: "50%",
  },
  idVerificationSuccessMainContainerChildContainer_textContainer: {
    alignItems: "center"
  },
  idVerificationSuccessMainContainerChildContainer_infotext: {
    textAlign: "center"
  },
  idVerificationSuccessMainContainerChildContainer_subinfotext: {
    textAlign: "center"
  },
  idVerificationSuccessMainContainerChildContainer_buttonContainer: {
    padding: 16,
    gap: 8
  },


  /** Disclaimer */
  checkInDisclaimerHeaderContainer: {
    display: "none"
  },
  checkInDisclaimerMainContainerChildContainer: {
    paddingTop: 40,
  },
  checkInDisclaimerRootContainer: {
    position: "absolute",
    height: "100%",
    width: "100%",
  },
  checkInDisclaimerHeaderTitleContainer: {

  },
  checkInDisclaimer_HeaderTitle: {

  },
  checkInDisclaimer_webview: {
    borderColor: "rgba(0, 0, 0, 0.10)",
    borderWidth: 0.5,
    borderRadius: 8,
    // flex: 1,
    // backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  checkInDisclaimer_textContainer: {

  },
  checkInDisclaimer_checkbox: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 16,
    marginTop: 20,
  },
  checkInDisclaimer_signature: {
    marginVertical: 16,
    borderColor: "rgba(0, 0, 0, 0.10)",
    borderWidth: 0.5,
    borderRadius: 8,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    height: 200,
    width: "100%",
  },
  checkInDisclaimer_signature_canvas: {
    backgroundColor: COLORS.BACKGROUND_COLOR,
    height: 200,
  },
  disclaimerFooterContainer: {
    width: '100%',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },
  checkInDisclaimer_checkbox_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "left",
    marginRight: 24, 
    marginLeft: 16, 
    marginTop: -5
  },


  /* Card Validation */
  cardValidationRootContainer: {

  },
  cardValidationMainContainer: {

  },
  cardValidationHeaderContainer: {

  },
  cardValidationHeaderTitleContainer: {

  },
  cardValidationHeaderTitle: {

  },
  cardValidationHeaderSubTitle: {

  },
  cardValidationMainContainerChildContainer: {
    paddingVertical: 16,
    gap: 24
  },
  cardValidationChildContainer_buttonContainer: {
    paddingVertical: 16,
    gap: 8
  },

  elavonCardContainer: {
    // display: "flex",
    // height: "70%",
    flex: 1, // important to apply margin top
    borderWidth: 0.5,
    borderRadius: 16,
    overflow: "hidden",
    borderColor: COLORS.BACKGROUND_COLOR,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  elavonCardContainer_iframe: {
    flex: 1,
    borderWidth: 0.5,
    borderRadius: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  elavonCardContainer_webview: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },

  shift4CardContainer: {
    flex: 1,
    overflow: "hidden",
    borderColor: COLORS.BACKGROUND_COLOR,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  
  shift4CardContainer_iframe: {
    flex: 1,
    borderWidth: 0,
    borderRadius: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  shift4CardContainer_webview: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },

  pciProxyCardContainer: {
    // display: "flex",
    // height: "70%",
    flex: 1, // important to apply margin top
    // borderWidth: 0.5,
    // borderRadius: 16,
    minHeight: 180,
    overflow: "hidden",
    borderColor: COLORS.BACKGROUND_COLOR,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  pciProxyCardContainer_iframe: {
    flex: 1,
    borderWidth: 0,
    borderRadius: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  pciProxyCardContainer_webview: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },




  additionalDetailsRootContainer: {

  },
  additionalDetailsMainContainer: {

  },
  additionalDetailsHeaderContainer: {

  },
  additionalDetailsHeaderTitleContainer: {

  },
  additionalDetailsHeaderTitle: {

  },
  additionalDetailsHeaderSubTitle: {

  },
  additionalDetailsMainContainerChildContainer: {

  },

  dynamicFormMainContainer: {
    flex: 1
  },
  dynamicFormChildContainer: {
    flex: 1,
    gap: 24
  },
  dynamicFormChildContainer_nestedObjContainer: {
    gap: 4
  },
  dynamicFormChildContainer_nestedObjContainer_heading: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textTransform: "capitalize",
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  dynamicFormChildContainer_nestedObjContainer_description: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textTransform: "capitalize",
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  dynamicFormChildContainer_nestedObjInnerContainer: {
    marginTop: 24,
    gap: 16
  },
  dynamicFormCheckboxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    paddingVertical: 16
  },
  dynamicFormCheckBox: {
    borderRadius: 10,
  },
  dynamicFormCheckBoxText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  noticeText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  addressCointainer: {
    flex: 1,
    gap: 16
  },
  addressChildCointainer: {
    flex: 1,
    gap: 8
  },

  dynamicFormButtonContainer: {
    paddingVertical: 16,
    gap: 16
  },




  preCheckInRootContainer: {

  },
  preCheckInMainContainer: {

  },
  preCheckInHeaderContainer: {
    // maxHeight: 393
  },
  preCheckInContainerHeaderImgContainer: {
    width: "100%",
    maxWidth: 1000,
    margin: "auto",
    padding: 28,
    paddingTop: 40,
    justifyContent: "center",
    alignItems: 'center',
    height: 392
  },
  preCheckInContainerHeaderImgBackground: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    width: 180,
    height: 180,
    borderRadius: 90,
    alignItems: 'center',
    justifyContent: 'center'
  },
  preCheckInContainerHeaderImg: {
    width: 70,
    height: 70,
    tintColor: COLORS.SECONDARY_TEXT_COLOR
  },
  preCheckInHeaderTitleContainer: {

  },
  preCheckInHeaderTitle: {

  },
  preCheckInHeaderSubTitle: {

  },
  preCheckInMainContainerChildContainer: {

  },
  preCheckInMainContainerChildContainer_infoText: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },

  preCheckInMainContainerChildContainer_buttonContainer: {
    padding: 16,
    gap: 8
  },

  /** Accompany Guest Input */
  accompanyGuestDetailsMainContainer: {
    paddingBottom: 88
  },
  accompanyGuestTextContainer: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  accompanyGuestInputGuestHeading: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  accompanyGuestCheckboxText: {
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
  },
  accompanyGuestCheckBox: {
    borderRadius: 10,
  },
  accompanyGuestInputGuestChildContainer: {
    // gap: 16,
    paddingTop: 16,
    paddingBottom: 40,
  },
  accompanyGuestLastNameContainer: {
    paddingTop: 16,
  },
  accompanyGuestCheckboxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    paddingVertical: 16
  },

  accompanyGuestChildCheckboxContainer: {
    flexDirection: "row",
    gap: 16,
    justifyContent: "center",
    alignItems: "center",
  },

  accompanyGuestCheckboxInputContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: 56,
  },
  accompanyGuestCheckboxInputText: {
    width: 115,
    // height: 52,
  },

  /** Accompany Guest List */
  accompanyGuestDetailsReviewItemText: {
      ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 24
  },


  accompanyGuestDetailsTitleContainer: {
    paddingBottom: 20,  
  },
  accompanyGuestDetailsTitle: {
    textAlign: 'center',
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  accompanyGuestUpdateContainer: {
    bottom: 0,
    width: '100%',
    position: 'absolute',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },


  checkInSuccessRootContainer: {

  },
  checkInSuccessMainContainer: {

  },
  checkInSuccessHeaderContainer: {

  },
  checkInSuccessContainerHeaderImgContainer: {
    width: "100%",
    maxWidth: 1000,
    margin: "auto",
    padding: 28,
    paddingTop: 40,
    justifyContent: "center",
    alignItems: 'center',
    height: 392
  },
  checkInSuccessContainerHeaderImgBackground: {
    backgroundColor: COLORS.SECONDARY_COLOR,
    width: 180,
    height: 180,
    borderRadius: 90,
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkInSuccessContainerHeaderImg: {
    width: 70,
    height: 70,
    tintColor: COLORS.SECONDARY_TEXT_COLOR
  },
  checkInSuccessHeaderTitleContainer: {

  },
  checkInSuccessHeaderTitle: {

  },
  checkInSuccessHeaderSubTitle: {

  },
  checkInSuccessMainContainerChildContainer: {
    gap: 24
  },
  checkInSuccessMainContainerChildContainer_textContainer: {
    gap: 16,
  },
  checkInSuccessMainContainerChildContainer_infotext: {
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: 'center'
  },
  checkInSuccessMainContainerChildContainer_infotext_roomnumber: {
    ...FONT_LARGE,
  },
  checkInSuccessMainContainerChildContainer_subinfotext: {
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center"
  },



  /* InnSpire ChatBot */

  innspireChatContainer: {
    flex: 1,
    height: "100%",
    width: "100%",
    overflow: "hidden",
    justifyContent: 'center',
    objectFit: "cover",
    maxWidth: GENERAL_MAX_WIDTH,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  innspireChatContainer_iframe: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },
  innspireChatContainer_webview: {
    flex: 1,
    backgroundColor: COLORS.BACKGROUND_COLOR
  },



  /**
 *
 * NOTIFICATION
 *
 */

  notificationsRootContainer: {

  },
  notificationsMainContainer: {

  },
  notificationsMainContainerChildContainer: {

  },
  noMessageContainer: {
    justifyContent: "center",
    alignItems: "center",
    gap: 16,
    paddingVertical: 16
  },
  noMessageContainer_img: {
    width: 80,
    height: 80
  },
  noMessageContainer_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    textAlign: "center",
    textTransform: "capitalize",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  notification_itemContainer: {

  },
  notificationdot_container: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    paddingRight: 8,
  },
  notificationDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  notificationDot_placeholder: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },
  notification_itemContainer_textContainer: {

  },
  notification_itemContainer_textContainer_title: {

  },
  notification_itemContainer_textContainer_subtitle: {

  },
  notification_itemContainer_arrow: {

  },

  /**
   *
   * NOTIFICATION DETAIL
   *
   */
  notificationDetailRootContainer: {

  },
  notificationDetailHeaderContainer: {

  },
  notificationDetailHeaderTitleContainer: {

  },
  notificationDetailHeaderTitle: {

  },
  notificationDetailMainContainer: {

  },
  notificationDetailMainContainerChildContainer: {
    gap: 24
  },
  notificationDetailContainer: {
    gap: 24
  },
  notificationDetailContainer_datetext: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  notificationDetailContainer_primarytext: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  notificationDetailContainer_secondarytext: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },



  /**
 *
 * HCommerce
 *
 */

  hcommerceRootContainer: {

  },
  hcommerceMainContainer: {

  },
  hcommerceHeaderContainer: {

  },
  hcommerceHeaderImg: {

  },
  hcommerceHeaderTitleContainer: {

  },
  hcommerceHeaderTitle: {

  },
  hcommerceHeaderSubTitle: {

  },
  hcommerceMainContainerChildContainer: {

  },

  hcommerce_itemContainer: {

  },
  hcommerce_itemContainer_image: {

  },
  hcommerce_itemContainer_textContainer: {

  },
  hcommerce_itemContainer_textContainer_title: {

  },
  hcommerce_itemContainer_arrow: {

  },


  hcommerce_storelevel1_item_image: {
    objectFit: "cover",
    borderRadius: 10
  },
  hcommerce_storelevel1_MainContainer: {
    flex: 1
  },
  hcommerce_storelevel1_HeaderContainer: {

  },
  hcommerce_storelevel1_HeaderImg: {
    display: "none"
  },
  hcommerce_storelevel1_HeaderTitleContainer: {

  },
  hcommerce_storelevel1_HeaderTitle: {

  },
  hcommerce_storelevel1_MainContainerChildContainer: {
    flex: undefined,
    paddingBottom: 148
  },

  hcommerce_storelevel1_PillContainer: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    marginBottom: 0
  },
  hcommerce_storelevel1_Pill: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderBottomWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.10)"
  },
  hcommerce_storelevel1_Pill_Text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hcommerce_storelevel1_SelectedPill: {
    borderBottomWidth: 2,
    borderColor: COLORS.ACCENT_COLOR
  },
  hcommerce_storelevel1_SelectedPill_Text: {
    color: COLORS.ACCENT_COLOR
  },

  hcommerce_storelevel1_ChildContainer: {
    gap: 16,
    paddingVertical: 16
  },
  hcommerce_storelevel1_ChildContainer_Title: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hcommerce_storelevel1_ChildContainer_items_container: {

  },

  hcommerce_storelevel1_itemContainer: {

  },
  hcommerce_storelevel1_itemContainer_image: {

  },
  hcommerce_storelevel1_itemContainer_textContainer: {

  },
  hcommerce_storelevel1_itemContainer_textContainer_title: {

  },
  hcommerce_storelevel1_itemContainer_textContainer_currencytitle: {

  },
  hcommerce_storelevel1_itemContainer_textContainer_subtitle: {

  },
  hcommerce_storelevel1_itemContainer_arrow: {

  },


  hcommerce_storelevel2_item_image: {
    objectFit: "cover",
    borderRadius: 10
  },

  hcommerce_storelevel2_MainContainer: {
    flex: 1
  },

  hcommerce_storelevel2_HeaderContainer: {

  },
  hcommerce_storelevel2_HeaderImg: {
    display: "none"
  },
  hcommerce_storelevel2_HeaderTitleContainer: {

  },
  hcommerce_storelevel2_HeaderTitle: {

  },
  hcommerce_storelevel2_HeaderSubTitle: {

  },

  hcommerce_storelevel2_MainContainerChildContainer: {
    flex: undefined,
    paddingBottom: 148
  },
  hcommerce_storelevel2_ChildContainer_items_container: {

  },
  hcommerce_storelevel2_itemContainer: {

  },
  hcommerce_storelevel2_itemContainer_image: {

  },
  hcommerce_storelevel2_itemContainer_textContainer: {

  },
  hcommerce_storelevel2_itemContainer_textContainer_title: {

  },
  hcommerce_storelevel2_itemContainer_textContainer_subtitle: {

  },
  hcommerce_storelevel2_itemContainer_arrow: {

  },


  hcommerce_iteminfo_container: {
    maxHeight: 666,
    minHeight: 500,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    overflow: "hidden",
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  hcommerce_iteminfo_mainContainer: {
    paddingBottom: 20
  },
  hcommerce_iteminfo_HeaderContainer: {

  },
  hcommerce_iteminfo_HeaderImg: {

  },
  hcommerce_iteminfo_HeaderTitleContainer: {
    paddingTop: 48
  },
  hcommerce_iteminfo_HeaderTitle: {

  },
  hcommerce_iteminfo_HeaderSubTitle: {

  },

  hcommerce_iteminfo_MainContainerChildContainer: {
    gap: 24
  },

  hcommerce_iteminfo_MainContainerChildContainer_amount_container: {
    display: "flex",
    flexDirection: 'row',
    width: "100%",
    alignItems: "center",
    justifyContent: 'space-between'
  },
  hcommerce_iteminfo_MainContainerChildContainer_amount_container_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },






  additem_controls: {
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    gap: 16,
  },
  additem_controls_sub_container: {
    
  },
  additem_controls_sub_container_img: {
    width: 24,
    height: 24,
  },
  additem_controls_qty_text: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },


  additem_controls2: {
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    gap: 16,
  },
  additem_controls_sub_container2: {
    padding: 8,
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  additem_controls_sub_container_img2: {
    width: 20,
    height: 20,
    tintColor: COLORS.SECONDARY_TEXT_COLOR,
    filter: "invert(1)"
  },
  additem_controls_qty_text2: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },


  // H COMMERCE - UpdateItemAddOns
  AddOnsModalContent: {
    maxHeight: 666,
    height: "100%",
    minHeight: 610,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingBottom: 40,
    justifyContent: "flex-start",
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  AddOnsModalContent_maincontainer: {

  },
  AddOnsModalContent_childcontainer_header_container: {
    height: 'auto',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 8,
    paddingTop: 16
  },
  AddOnsModalContent_childcontainer_header_container_title: {
    ...PRIMARY_FONT,
    ...FONT_LARGE,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  AddOnsModalContent_childcontainer_header_container_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  AddOnsModalContent_childcontainer: {
    paddingHorizontal: 24,
    gap: 24,
    maxHeight: 300
  },

  AddOnsModalContent_addons_main_container: {
    gap: 8,
    height: 350
  },
  AddOnsModalContent_addons_child_container: {
    gap: 8,
  },
  AddOnsModalContent_addons_itemContainer: {
    
  },
  AddOnsModalContent_addons_itemContainer_image: {

  },
  AddOnsModalContent_addons_itemContainer_textContainer: {
    height: "auto"
  },
  AddOnsModalContent_addons_itemContainer_textContainer_title: {
    
  },
  AddOnsModalContent_addons_itemContainer_textContainer_subtitle: {

  },
  AddOnsModalContent_addons_itemContainer_textContainer_price: {

  },


  AddOnsModalContent_childcontainer_quantity_container: {
    display: "flex",
    flexDirection: 'row',
    width: "100%",
    alignItems: "center",
    justifyContent: 'space-between'
  },
  AddOnsModalContent_childcontainer_quantity_container_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },



  myOrder_container: {

  },
  myOrder_container_price_container: {
    display: "flex",
    flexDirection: 'row',
    width: "100%",
    alignItems: "center",
    justifyContent: 'space-between'
  },
  myOrder_container_price_container_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR
  },
  myOrder_container_count_container: {
    display: "flex",
    width: 20,
    height: 20,
    borderRadius: 10,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: 'center',
    backgroundColor: COLORS.ACCENT_COLOR
  },
  myOrder_container_count_container_text: {
    ...SECONDARY_FONT,
    color: COLORS.ACCENT_Text_COLOR
  },


  hcommerce_orderdetails_MainContainer: {

  },

  hcommerce_orderdetails_HeaderContainer: {

  },
  hcommerce_orderdetails_HeaderTitleContainer: {

  },
  hcommerce_orderdetails_HeaderTitle: {

  },
  hcommerce_orderdetails_HeaderSubTitle: {

  },

  hcommerce_orderdetails_HeaderOrderDetailsContainer: {
    maxHeight: 350,
    borderRadius: 12,
    overflow: 'hidden'
  },
  hcommerce_orderdetails_itemContainer: {
    paddingHorizontal: 16
  },
  hcommerce_orderdetails_itemContainer_image: {

  },
  hcommerce_orderdetails_itemContainer_textContainer: {

  },
  hcommerce_orderdetails_itemContainer_textContainer_title: {

  },
  hcommerce_orderdetails_itemContainer_textContainer_subtitle: {

  },
  hcommerce_orderdetails_itemContainer_textContainer_tertiaryContainer: {

  },


  hcommerce_orderdetails_MainContainerChildContainer: {
    gap: 16
  },
  hcommerce_orderdetails_MainContainerChildContainer_titlecontainer: {
    gap: 8,
    paddingTop: 48,
    paddingHorizontal: 16
  },
  hcommerce_orderdetails_MainContainerChildContainer_title: {
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    textTransform: "uppercase",
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  hcommerce_orderdetails_MainContainerChildContainer_subtitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    textAlign: "center",
    paddingHorizontal: 24,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
  },


  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: 'center',
    padding: 16,
    gap: 8
  },
  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container: {
    display: 'flex',
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: 'flex-end',
    width: "100%"
  },
  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },
  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

  hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_gratitude_top_container: {
    display: 'flex',
    justifyContent: "space-between",
    alignItems: 'flex-end',
    width: "100%",
    marginTop: 8
  },

  gratitude_container: {
    width: "100%",
    marginTop: 8
  },
  gratitude_Slider: {
    width: "100%",
  },

  hcommerce_orderdetails_MainContainerChildContainer_buttonContainer: {
    gap: 8,
    paddingBottom: 40,
    position: "sticky",
    backgroundColor: COLORS.BACKGROUND_COLOR,
    bottom: 0,
    padding: 24
  },



  /*guest request */
  guestrequest_RootContainer: {

  },
  guestrequest_MainContainer: {
    paddingBottom: 148
  },

  guestrequest_HeaderContainer: {

  },
  guestrequest_HeaderImg: {

  },
  guestrequest_HeaderTitleContainer: {

  },
  guestrequest_HeaderTitle: {

  },
  guestrequest_HeaderSubTitle: {

  },

  guestrequest_MainContainerChildContainer: {
    paddingHorizontal: 0,
  },
  guestrequest_ChildTitleContainer:{
    marginHorizontal: 16,
    marginBottom: 16
  },
  guestrequest_ChildTitle:{

  },

  guestrequest_childcontainer_itemContainer: {
    paddingHorizontal: 16,
  },
  guestrequest_childcontainer_itemContainer_image: {

  },
  guestrequest_childcontainer_itemContainer_textContainer: {

  },
  guestrequest_childcontainer_itemContainer_textContainer_title: {

  },
  guestrequest_childcontainer_itemContainer_textContainer_subtitle: {

  },
  guestrequest_childcontainer_itemContainer_arrow: {

  },
  guestrequest_childcontainer_itemContainer_arrow_img: {

  },

  guestrequest_childcontainer_itemContainer_selected: {
    backgroundColor: COLORS.ACCENT_COLOR
  },
  guestrequest_childcontainer_itemContainer_image_selected: {

  },
  guestrequest_childcontainer_itemContainer_textContainer_selected: {

  },
  guestrequest_childcontainer_itemContainer_textContainer_title_selected: {
    color: COLORS.ACCENT_Text_COLOR
  },
  guestrequest_childcontainer_itemContainer_textContainer_subtitle_selected: {
    color: COLORS.ACCENT_Text_COLOR
  },
  guestrequest_childcontainer_itemContainer_arrow_selected: {

  },
  guestrequest_childcontainer_itemContainer_arrow_img_selected: {
    tintColor: COLORS.ACCENT_Text_COLOR,
    filter: "invert(1)"
  },
  guestrequest_button_container: {

  },

  guestrequestdetails_RootContainer: {

  },
  guestrequestdetails_MainContainer: {
    flexGrow: 1,
    height: "100%"
  },
  guestrequestdetails_HeaderContainer: {

  },
  guestrequestdetails_HeaderTitleContainer: {
    
  },
  guestrequestdetails_HeaderTitle: {

  },
  guestRequestDetailsFooterCotainer: {
    padding: 16,
    gap: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },

  guestrequestdetails_itemContainer: {
    // padding: 16,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.2)",
    // shadowColor: "rgba(0, 0, 0, 0.2)",
  },
  guestrequestdetails_itemContainer_image: {

  },
  guestrequestdetails_itemContainer_textContainer: {
    height: "auto"
  },
  guestrequestdetails_itemContainer_textContainer_title: {

  },
  guestrequestdetails_textContainer_subtitle: {

  },
  guestrequestdetails_itemContainer_arrow: {

  },
  guestrequestdetails_itemContainer_arrow_img: {
    tintColor: COLORS.PRIMARY_TEXT_COLOR,
    filter: "invert(1)"
  },

  guestrequestdetails_MainContainerChildContainer: {
    maxHeight: 250,
    shadowColor: "rgba(0, 0, 0, 0.2)",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    zIndex: 1,
  },

  guestrequestdetails_buttonContainer: {
    gap: 8,
  },


  // View Bill------->
  billContainer: {
    padding: 20,
  },
  intervalError: {
    fontWeight: '400',
    alignSelf: 'center',
    textAlign: 'center',
    top: 10,
    ...SECONDARY_FONT,
    ...FONT_LARGE,
  },
  billHeaderTitle: {
    fontWeight: '400',
    textAlign: 'center',
    ...PRIMARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  billHeaderSubTitle: {
    textAlign: 'center',
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  detailsContainer: {
    marginTop: 10,
  },
  detailsContainerTitle: {
    textAlign: 'center',
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginTop: 20,
    textTransform: 'uppercase'
  },
  purcharseBillText: {
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    fontSize: 25,
    ...SECONDARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  guestItineraryDetailsHeaderTitle:{
    ...FONT_MEDIUM,
  },

  guestItineraryDetails_subHeading:{
    textAlign: "center",
    ...PRIMARY_FONT,
    ...FONT_SMALL,
  },


  guestItineraryDetails_bodyText: {
    textAlign: "center",
    ...SECONDARY_FONT,
    ...FONT_SMALL,
  },
  


  reviewBill: {
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  viewbillMainContainer: {
    paddingBottom: 90
  },
  viewBillDateContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: 'space-between',
    marginVertical: 24,
    gap: 8,
  },
  viewBillDateItemContainer: {
    flex: 1,
    width: "auto",
    borderWidth: 0.5,
    borderColor: COLORS.ACCENT_COLOR,
    paddingVertical: 16,
    paddingHorizontal: 10
  },
  viewBillDateItemTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  viewBillDateItemSubTitle: {
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    fontWeight: '400',
    textAlign: 'center',
    alignSelf: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },

  billCheckoutBtnContainer: {
    bottom: 0,
    width: '100%',
    position: 'absolute',
    padding: 16,
    backgroundColor: COLORS.BACKGROUND_COLOR,
    gap: 10,
  },
  historyContainer: {
    marginTop: 40

  },
  ViewBill_itemContainer_textContainer_noHistory_container: {
    alignItems: "center",
    justifyContent: "center",
    height: null,
    paddingBottom: 20,
  },
  ViewBill_itemContainer_textContainer_noHistory: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: 'center',
  },
  viewBill_Item_textContainer: {
    borderBottomWidth: 1,
    paddingHorizontal: 10,
    paddingVertical: 0,
    backgroundColor: COLORS.BACKGROUND_COLOR,
  },
  ViewBill_itemContainer_textContainer_title:{
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textAlign: "left",
  },
  ViewBill_itemContainer_textContainer_subtitle: {

  },
  viewBill_infoModalRowView:{
    flexDirection: 'row', 
    justifyContent: 'space-evenly', 
    marginVertical: 10
  },
  viewBill_infoModalSubheader:{
    ...SECONDARY_FONT,
    ...FONT_MEDIUM,
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 15,
    textAlign: 'center'
  },
  viewBill_infoModalTitle:{
    ...SECONDARY_FONT,
    ...FONT_XLARGE,
    color: COLORS.PRIMARY_TEXT_COLOR,
    textTransform: 'uppercase',
    textAlign: "center",
    paddingVertical: 8
  },
  viewBillConfirmCheckoutHeaderContainer: {
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  },
  viewBillConfirmCheckoutMainContainerHeaderImg: {
    height: 55,
    width: 55,
    margin: null
  },

  infoModalRowView: { flexDirection: 'row', justifyContent: 'space-evenly', marginVertical: 10 },
  // title: {
  //   fontSize: 35,
  //   fontWeight: 'bold',
  //   textAlign: 'center',
  //   marginVertical: 10,
  //   color: SELECTOR_COL_SECONDARY,
  // },
  total: {
    textAlign: 'center',
    marginTop: 15,
    color: COLORS.PRIMARY_TEXT_COLOR,
    ...SECONDARY_FONT,
    fontSize: 20,
  },
  amount: {
    textAlign: 'center',
    color: COLORS.PRIMARY_TEXT_COLOR,
    marginBottom: 10,
    ...SECONDARY_FONT,
    fontSize: 35,
  },

  date: {
    fontSize: 14,
    fontWeight: '500',
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  roomChargesTitle: {
    fontSize: 25,
    fontWeight: 'bold',
    marginTop: 20,
    marginVertical: 15,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  billItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 5,
    paddingVertical: 20,
    marginHorizontal: 15,
    paddingHorizontal: 13,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    padding: 5,
    color: COLORS.PRIMARY_TEXT_COLOR,
  },
  billDescription: {
    fontSize: 16,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: '500',
    width: '70%',
  },
  billAmount: {
    fontSize: 16,
    color: COLORS.PRIMARY_TEXT_COLOR,
    fontWeight: '600',
    width: '30%',
    textAlign: 'right',
  },



  /**
   *
   * LOADER
   *
   */
  loaderContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  customLoader: {
    
  },
  customLoader_lottie: {
    flex: 1,
    height: 50,
    width: 50
  },
  customLoader_medium: {
    height: 40,
    width: 40,
  },
  customLoader_small: {
    height: 30,
    width: 30,
  },

  /**
   * 
   * PROMO WIDGET
   * 
   */
  promoWidgetContainer: {
    backgroundColor: COLORS.PRIMARY_COLOR,
    minHeight: 262,
    maxHeight: 393,
    justifyContent: "center",
  },
  promoWidgetHeaderTitle: {
    ...PRIMARY_FONT,
    ...FONT_XXLARGE,
    color: COLORS.WHITE,
    textAlign: "center",
    width: "100%",
    textTransform: "uppercase",
  },
  promoWidgetHeaderSubtitle: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.WHITE,
    textAlign: "center",
    width: "100%",
    paddingHorizontal: 35,
  },
  promoWidgetImageStyle: {
    width: "100%",
    maxWidth: null,
    position: "absolute",
  },
  promoWidgetImage: {
    width: '100%',
    height: 262,
    objectFit: 'cover',
  },


  // Doorkey Styling

  chamberRootContainer: {

  },
  chamberMainContainer: {
    flexGrow: 0,
  },
  chamberHeaderContainer: {

  },
  chamberHeaderTitleContainer: {

  },
  chamberHeaderTitle: {

  },
  chamberContainerHeaderSubTitleContainer: {

  },
  chamberHeaderSubTitle: {
    ...FONT_SMALL,
  },
  chamberHeadertertiaryTitle: {
    ...SECONDARY_FONT,
    ...FONT_XLARGE,
    textAlign: "center",
    color: COLORS.ACCENT_COLOR
  },

  chamberMainContainerChildContainer: {
    gap: 24
  },

  chamberKey_ringsAnimationWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    width: 256,
    height: 256,
    margin: "auto",
  },
  chamberKey_innerrings: {
    borderWidth: 1,
    borderColor: '#000',
  },
  chamberKey_innerrings_text: {
    ...FONT_XSMALL,
    ...SECONDARY_FONT,
    width: 56, 
    textAlign: "center",
    color: COLORS.BACKGROUND_COLOR_CONTRAST
  },

  chamberKey_guidecontianer: {
    display: "flex", 
    justifyContent:'center', 
    alignItems: "center", 
    width: "100%", 
    gap: 24
  },
  chamberKey_guidecontianer_img: {
    
  },
  chamberKey_guidecontianer_guidetext: {
    ...SECONDARY_FONT,
    ...FONT_SMALL,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: "center",
  },

  

  // Doorkey index

  doorkey_container: {
    minHeight: 500,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 20,
    gap: 30,
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
  doorkey_card_image: {
    width: "100%", 
    height: 225, 
    objectFit: "contain"
  },
  doorkey_card_roomnumber_container: {
    position: "absolute", 
    height: "100%", 
    display: "flex", 
    justifyContent: "center" 
  },
  doorkey_card_roomnumber: {
    transform: [{ rotate: '-90deg' }], 
    color: COLORS.WHITE
  },
  doorkey_card_animation_container: {
    width: "100%",
    height: "auto"
  },
  doorkey_card_animation_container_image: {
    width: "100%",
    height: 100,
    objectFit: "contain"
  },

  doorkey_card_log_container: {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center"
  },

  doorkey_card_logo: {
    height: 50, 
    width: 55
  },


  doorKeyButton: {
    width: '90%',
  },
  doorKeyButtonText: {

  },
  doorKeyOrText: {
    marginVertical: 10,
    fontWeight: 'bold',
    alignSelf: 'center',
    ...FONT_XLARGE,
    ...PRIMARY_FONT,
    color: COLORS.PRIMARY_TEXT_COLOR
  },

  // DoorKey Otp
  doorKeyOtpEmailTxt: {
    marginHorizontal: 16,
    textAlign: 'center',
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    ...FONT_LARGE,
    ...PRIMARY_FONT,
    marginBottom: 30,
    fontWeight: '500',
  },
  doorKeyOtpPinLabel: {
    fontWeight: 'bold',
    textAlign: 'center',
    color:  COLORS.BACKGROUND_COLOR_CONTRAST,
    ...FONT_MEDIUM,
    ...PRIMARY_FONT,
    marginBottom: 15,
  },
  doorKeyOtpPinContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 35,
    marginHorizontal: 16,
  },
  doorKeyOtpPinInput: {
    width: 35,
    height: 50,
    borderBottomWidth: 1,
    borderColor: COLORS.BACKGROUND_COLOR_CONTRAST,
    textAlign: 'center',
    fontSize: 24,
    color: COLORS.BACKGROUND_COLOR_CONTRAST,
    ...SECONDARY_FONT,
    fontWeight: undefined
  },


    /*  Floating Widget */
  floatingWidgetMainContainer: {
    position: 'absolute',
    bottom: 100,
    right: 20,
    zIndex: 1000,
    backgroundColor: COLORS.ACCENT_COLOR,
    borderRadius: 100,
    elevation: 5,

    justifyContent: 'center',
    alignItems: 'center',
    height: 56,
    width: 56,
  },
  floatingWidgetImageStyle:{
    width: 34,
    justifyContent: 'center',
    alignItems: 'center',
  },
  floatingWidgetImage: {
    height: 32,
    width: 24,
  },
  floatingWidgetFlatListContentContainer:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: "auto",
  },

});
